import { City } from "types/city.data"

import { mapCityResponse } from "../mapping/city.mapping"

import { cityResponseData } from "./city.response"

export const cityMapped: City = mapCityResponse(cityResponseData)
